import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16ece403"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["rowspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("td", {
    cols: "5",
    rowspan: _ctx.rowspan,
    class: "bracket"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([{ winner_left: _ctx.bracketwinner === 'top' }, "bracket__left"])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([{ winner_right: _ctx.bracketwinner === 'bottom' }, "bracket__right"])
    }, null, 2),
    _createElementVNode("div", {
      class: _normalizeClass([{ winner_middle: _ctx.bracketwinner !== '' }, "bracket__middle"])
    }, null, 2)
  ], 8, _hoisted_1))
}